import { ROUTES } from "@/shared/constants";

/**
 * Whether a primary nav item should appear selected for the current pathname.
 * Nested routes (e.g. /charm/:id) keep their parent selected.
 * Talent hall pages (/talent-hall/:id) belong under Halls (/talents), not Lobby.
 * Exact /talent-hall is the talent's own hall profile — not Halls.
 */
export const isNavItemSelected = (pathname: string, navPath: string): boolean => {
  if (pathname === navPath || pathname.startsWith(`${navPath}/`)) {
    return true;
  }

  if (navPath === ROUTES.TALENTS) {
    // Owner-only hall subpages stay under Profile, not Halls.
    if (pathname === ROUTES.TALENT_HALL_CARDS) return false;
    return pathname.startsWith(`${ROUTES.TALENT_HALL}/`);
  }

  if (navPath === ROUTES.LOBBY || navPath === ROUTES.ORGANIZATION_LOBBY) {
    return pathname === ROUTES.LOBBY || pathname === ROUTES.ORGANIZATION_LOBBY;
  }

  return false;
};
